module.exports = __webpack_public_path__ + "img/georgian_logo.39ed6334.png";